
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'5-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            메뉴 관리 - 공지사항 {{ $route.query.news_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.news_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='news_title'>타이틀<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'news_title'
                maxLength="300"
                placeholder = "타이틀을 입력해 주세요.(300자 이내)"
                v-model="formData.newsTitle"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.newsTitleError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='news_sub_title'>서브 타이틀<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'news_sub_title'
                maxLength="300"
                placeholder = "서브 타이틀을 입력해 주세요.(300자 이내)"
                v-model="formData.newsSubTitle"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.newsSubTitleError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='news_status'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="news_status"
                v-model="formData.newsStatus"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

          <div class="Admin_imgBanner_BoxWrap">
            <div class="Admin_imgBanner_BoxTit">메인 노출 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1080 x 1080px</p>
                <label for='news_main_image' class="Admin_imgBanner_Btn">
                  {{ $route.query.news_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'news_main_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="changeImage"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_Square">
                  <img
                    :src="formData.newsMainImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.newsMainImageURL"
                    alt="PC용 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.newsMainImageURLError}}</p>
              </div>
            </div>
          </div>

          <div class="Admin_editorBox_BoxWrap">
            <div class="Admin_editorBox_BoxTit">
              PC용 에디터
              <span> (스크린 최소 사이즈 기준 1200px)</span>
            </div>
            <custom-textarea
                v-model="formData.newsEditor"
                :id="'news_editor'"
              />
          </div>

           <div class="Admin_editorBox_BoxWrap">
            <div class="Admin_editorBox_BoxTit">
              모바일용 에디터
              <span> (스크린 최소 사이즈 기준 480px)</span>
            </div>
            <custom-textarea
              v-model="formData.newsEditorMobile"
              :id="'news_editor_mobile'"
              style="width:480px;"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import CustomTextarea from '../../ETC/CustomTextarea.vue'
import {
  get_news_one,
  insert_news,
  update_news
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminNewsManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner,
    CustomTextarea
  },
  setup () {
    return {
      formData: ref({
        newsTitle: '',
        newsSubTitle: '',
        newsStatus: 1,
        newsMainImage: '',
        newsMainImageURL: '',
        newsEditor: '',
        newsEditorMobile: ''
      }),
      errorData: ref({
        newsTitleError: '',
        newsSubTitleError: '',
        newsMainImageURLError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    changeImage: function (event_data) {
      if (event_data.target.files[0] !== undefined) {
        this.formData.newsMainImage = event_data.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          this.formData.newsMainImageURL = reader.result
        }
      }
    },
    check_form: function () {
      let continue_add = true
      if (this.formData.newsTitle === '') {
        this.errorData.newsTitleError = '타이틀을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.newsTitleError = ''
      }
      if (this.formData.newsSubTitle === '') {
        this.errorData.newsSubTitleError = '서브 타이틀을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.newsSubTitleError = ''
      }
      if (this.formData.newsMainImageURL === '') {
        this.errorData.newsMainImageURLError = '메인 노출 이미지를 등록해 주세요.'
        continue_add = false
      } else {
        this.errorData.newsMainImageURLError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.news_ID === undefined) {
          insert_news(
            this.formData.newsTitle,
            this.formData.newsSubTitle,
            this.formData.newsMainImage,
            this.formData.newsEditor,
            this.formData.newsEditorMobile,
            this.formData.newsStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminNewsManagement'
          })
        } else {
          update_news(
            this.$route.query.news_ID,
            this.formData.newsTitle,
            this.formData.newsSubTitle,
            this.formData.newsMainImage,
            this.formData.newsEditor,
            this.formData.newsEditorMobile,
            this.formData.newsStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminNewsManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.news_ID !== undefined) {
      get_news_one(this.$route.query.news_ID).then((result) => {
        this.formData.newsTitle = result[0].news_title
        this.formData.newsSubTitle = result[0].news_sub_title
        this.formData.newsMainImageURL = result[0].news_main_image
        this.formData.newsEditor = result[0].news_editor
        this.formData.newsEditorMobile = result[0].news_editor_mobile
        this.formData.newsStatus = result[0].news_status
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/MenuManagement/AdminNewsManagementAdd.vue